import { TopSection } from "src/components/_pages/access/top-section";
import { AccessSection } from "src/components/_pages/access/access-section";
import { Footer } from "src/components/footer";

const Access = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | ACCESS</title>
      <article>
        <TopSection />
        <AccessSection />
        <Footer />
      </article>
    </>
  );
};

export default Access;
